

require('../accessibility/directive');

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// Directives used in the template
(0, _squid.$registerDirective)('xoModal', function () {
    return {
        template: _template2['default'],
        restrict: 'E',
        replace: true,
        transclude: true,

        scope: {
            show: '=?',
            showCloseButton: '=?',
            onClose: '=?',
            overrideDefaultContainer: '@?' // Boolean to determine if default styling should be applied to container
        },

        controller: function controller($scope) {
            $scope.hideModal = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }

                $scope.show = false;

                if ($scope.onClose) {
                    $scope.onClose();
                }
            };
        }
    };
});

_squid.$registerDirective;


//////////////////
// WEBPACK FOOTER
// ./components/xo-ui-components/src/modal/directive.js
// module id = ./components/xo-ui-components/src/modal/directive.js
// module chunks = 1